import {Pipe, PipeTransform} from "@angular/core";
import {MarkOperator, MarkService} from "../services/mark.service";
import * as _ from "lodash";

function _transform(value: string, searchTerms: string[], operator: MarkOperator,
					service: MarkService): string {
	if (!value) {
		return '';
	}

	if (operator === null) {
		return service.sanitize(value);
	}

	let values;
	if ((<any>value instanceof  Date)){
		// we dont really want to support dates here, but this is better than nothing.
		// it is still very likely we will not match the way the date is displayed on the output
		value=value.toString();
		values = [value];
	}else if (_.isNumber(<any>value)){
		//value=""+value;
		values = [""+value];
	}else{
		values = value.match(/\S+\s*/g) || [];
	}

	return values.reduce((prev, v) => {
		return prev.concat(service.highlightField(v, searchTerms, operator,
			'<strong class="mark">', '</strong>'));
	}, '');
}

@Pipe({name: 'cpMark'})
export class MarkPipe implements PipeTransform {
	constructor(protected service: MarkService) {
	}

	transform(value: string, searchTerms: string[], operator: MarkOperator): string {
		return _transform(value,searchTerms,operator,this.service);
	}
}

@Pipe({name: 'cpMarkPure',pure:true})
export class MarkPipePure implements PipeTransform {
	constructor(protected service: MarkService) {
	}

	transform(value: string, searchTermsAsFullString: string, operator: MarkOperator): string {
		return _transform(value,searchTermsAsFullString.split(' '),operator,this.service);
	}
}
